import React from "react";
import "./experience.css";

const Experience = () => {
  return (
    <section id="experience">
      <h2>
        Experience <span className="dot">.</span>{" "}
      </h2>

      <div className="container about__container">
        {/* <div className="about__me"> */}
        <lord-icon
          src="https://cdn.lordicon.com/vyahiuge.json"
          trigger="loop"
          delay="2000"
          stroke="light"
          colors="primary:#7f00e0,secondary:#aadcec"
          style={{ width: "350px", height: "350px" }}
        ></lord-icon>
        {/* <div className="about__me-image">
            <img src={myImage} alt="Me" />
          </div> */}
        {/* </div> */}

        <div className="about__content">
          <section id="experience">
            <div className="experience-entry">
              <h3 className="company-name">Cybage Software</h3>
              <h4 className="designation">
                Lead Software Engineer (Feb 2022 - Present)
              </h4>
              <ul className="experience-list">
                <li>
                  <span className="client-details">
                    <br />
                    <a href="https://bridgestonetire.com" className="client-link">
                      Bridgestone
                    </a>
                    <br />
                    Currently leading the development of a web component
                    library, aiming to streamline future web development
                    projects within Bridgestone. This initiative will enhance
                    maintainability, reusability, and development efficiency.
                  </span>
                </li>
                <li>
                  <span className="client-details">
                    <br />
                    <a
                      href="https://sksbusinessservices.com"
                      className="client-link"
                    >
                      SKS Business Services
                    </a>
                    <br />
                    Led the development of a scalable React.js architecture from
                    scratch to manage the work and tasks of their employees
                    internally, resulting in a 30% time reduce for their
                    operations.
                  </span>
                </li>
              </ul>
            </div>
            <div className="experience-entry">
              <h3 className="company-name">Coforge</h3>
              <h4 className="designation">
                Senior Software Engineer (Apr 2020 - Jan 2022)
              </h4>
              <ul className="experience-list">
                <li>
                  <span className="client-details">
                    <br />
                    <a href="https://seic.com" className="client-link">
                      SEI{" "}
                    </a>
                    <br />
                    Finance Domain: Successfully managed client requirements,
                    delivering features on time through parallel sprint
                    implementation. Demonstrated full-stack development
                    skills by managing client-side code (JavaScript/jQuery),
                    contributing to stored procedures, and migrating modules to
                    React as part of a MERN Stack project.{" "}
                  </span>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default Experience;
